import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { injectIntl, defineMessages } from 'react-intl'
import { Title, BackLink, PageHeader, YoutubeVideo } from '../components'
import germanChannels from '../channels/languages/german'
import englishChannels from '../channels/languages/english'
import spanishChannels from '../channels/languages/spanish'
import frenchChannels from '../channels/languages/french'


class VideosProfilePage extends React.Component {
  state = {
    currentChannel: null,
  }

  
  componentDidMount() {
    const { match } = this.props

    const subject = match.params.subject
    const channels = {
      'english': englishChannels,
      'german': germanChannels,
      'spanish': spanishChannels,
      'french': frenchChannels,
    }
    const currentChannel = channels[subject].find(ch => ch.id == match.params.id)

    this.setState({
      currentChannel: currentChannel
    })
  }

  render() {
    const { intl } = this.props
    const { currentChannel } = this.state

    if (!currentChannel) {
      return null
    }

    return (
      <div className="page">
        <BackLink />
        <PageHeader
          title={currentChannel.name}
        />
        <div className="row spacing-bottom">
          {
            currentChannel.profileLinks ?
              currentChannel.profileLinks.map(profileLink => (
                <a href={profileLink.url} target="_blank">
                  <button className="button positive-button disable-horizontal-spacing">
                    {profileLink.label}
                  </button>
                </a>
              ))
            :
            null
          }
        </div>
        <div className="row spacing-bottom">
          <h3>{intl.formatMessage(messages.title)}</h3>
        </div>
        <div className="videos-grid width-full">
        {
          currentChannel.videos.map(video => (
            <div key={video}>
              {/* <h3>{video}</h3> */}
              <YoutubeVideo videoUrl={video} />
            </div>
          ))
        }
        </div>
      </div>
    )
  }
}

VideosProfilePage.propTypes = {
  intl: PropTypes.object.isRequired,
}

export default injectIntl(VideosProfilePage)

const messages = defineMessages({
  title: {
    id: 'videosProfile.page.title',
    defaultMessage: 'Videá',
  },
})



// WEBPACK FOOTER //
// ./src/browser/pages/VideosProfilePage.js